import { $on, $off, $emit } from './gogocodeTransfer'
const Bus = {}

const NativeBridgeEvents = {
  search: 'search',
  delSession: 'delSession',
  addNewSession: 'addNewSession',
  getDetailById: 'getDetailById',
  hostReady: 'hostReady'
}
// 给端上暴露的方法，统一入口
window.ChatglmOpenNativeBridge = {
  calljs: function (eventName, params) {
    const event = NativeBridgeEvents[eventName]
    if (event) {
      $emit(Bus, event, params)
    } else {
      console.log(`event: ${eventName} isn't registered`)
    }
  }
}
// 注册端上调用 事件
function addNativeEventListener(eventName, func, vueInstance) {
  $on(Bus, eventName, func)
  // 如果是组件内注册的方法，需要在组件卸载前取消注册，防止重复调用
  if (vueInstance) {
    $on(vueInstance, 'hook:beforeDestroy', () => {
      $off(Bus, eventName, func)
    })
  }
}
// 端 jsb 调用统一入口
function JSBridgeCall(eventName, params = {}) {
  if (window.ChatglmOpenJSBridge) {
    const paramsString = JSON.stringify(params)
    window.ChatglmOpenJSBridge.callNative(eventName, paramsString)
  }
  if (window.webkit?.messageHandlers?.ChatglmOpenJSBridge?.postMessage) {
    window.webkit.messageHandlers.ChatglmOpenJSBridge.postMessage({
      eventName: eventName,
      paramsString: JSON.stringify(params)
    })
  }
}
export { addNativeEventListener, JSBridgeCall, NativeBridgeEvents }
